import React, { useState } from "react";

import { getLabel } from "../../tools/Dictionary";

import "./Privacy.css";


const PRIVACYTEXT = {
  "EN": `**Privacy Policy for Innovair Solutions**

_Last updated: 2025-07-24_

**1. Introduction**  
Innovair Solutions (“we”, “us”, “our”) respects your privacy. This policy explains what data we collect, how we use it, and your choices.

**2. Contact Information**  
Developer: Innovair Solutions  
Email: info@innovairsolutions.com

**3. Data We Collect**  
- **Personal Data**: Email address (if you sign up), name (optional).  
- **Device & Usage Data**: OS version, device model, crash logs, anonymized analytics.  
- **Support & Troubleshooting Logs**: If you contact us for troubleshooting, we keep a record of your support requests (timestamps and content) to improve our service.

**4. How We Use Your Data**  
- To provide and maintain the app’s functionality.  
- To respond to your support inquiries and track troubleshooting history.  
- To analyze app performance and fix bugs.

**5. Data Sharing & Disclosure**  
We do **not** sell or share your personal data with third parties except:  
- Service providers (e.g. analytics, hosting) under strict confidentiality.  
- If required by law or to protect our rights.

**6. Data Retention**  
We retain personal and support‑request data as long as needed to deliver the app and for legal compliance.

**7. Children’s Privacy**  
We do not knowingly collect data from children under 13. If you are under 13, please do not use this app. Parents may request deletion of any data at any time.

**8. Your Rights**  
You can request access, correction, or deletion of your personal data by emailing us.

**9. Changes to This Policy**  
We may update this policy. We’ll post changes here with a new “Last updated” date.

**10. Contact Us**  
If you have questions, contact Innovair Solutions at info@innovairsolutions.com.

  `,
  "FR": `**Politique de confidentialité d’Innovair Solutions**

_Dernière mise à jour : 24 juillet 2025_

**1. Introduction**  
Innovair Solutions (« nous », « notre », « nos ») respecte votre vie privée. Cette politique explique les données que nous collectons, comment nous les utilisons et vos choix.

**2. Informations de contact**  
Développeur : Innovair Solutions  
Email : info@innovairsolutions.com

**3. Données que nous collectons**  
- **Données personnelles** : adresse email (si vous vous inscrivez), nom (facultatif).  
- **Données d’appareil et d’utilisation** : version du système d’exploitation, modèle d’appareil, rapports de plantage, analyses anonymisées.  
- **Journaux de support et de dépannage** : si vous nous contactez pour une assistance, nous conservons un historique de vos demandes (horodatages et contenu) pour améliorer notre service.

**4. Comment nous utilisons vos données**  
- Pour fournir et maintenir le fonctionnement de l’application.  
- Pour répondre à vos demandes d’assistance et suivre l’historique des dépannages.  
- Pour analyser les performances de l’application et corriger les bugs.

**5. Partage et divulgation des données**  
Nous ne vendons ni ne partageons vos données personnelles avec des tiers, sauf :  
- Prestataires de services (analyse, hébergement) soumis à des obligations de confidentialité strictes.  
- Si la loi l’exige ou pour protéger nos droits.

**6. Conservation des données**  
Nous conservons les données personnelles et les journaux de support aussi longtemps que nécessaire pour fournir l’application et pour nous conformer aux obligations légales.

**7. Confidentialité des enfants**  
Nous ne collectons pas sciemment de données d’enfants de moins de 13 ans. Si vous avez moins de 13 ans, veuillez ne pas utiliser cette application. Les parents peuvent demander la suppression de toute donnée à tout moment.

**8. Vos droits**  
Vous pouvez demander l’accès, la correction ou la suppression de vos données personnelles en nous contactant par email.

**9. Modifications de cette politique**  
Nous pouvons mettre à jour cette politique. Nous publierons les modifications ici avec une nouvelle date de « Dernière mise à jour ».

**10. Nous contacter**  
Si vous avez des questions, contactez Innovair Solutions à info@innovairsolutions.com.  

  `,
}

const PrivacyPage = (props) =>
{

  //State
  const [language, setLanguage] = useState("FR");

  return (
    <div className="page_body_cont">

      <div className="page_title" style={{ marginBottom: "20px" }}>
        {getLabel("PrivacyPage", "Privacy Policy")}
      </div>

      <input
          type="button"
          className="page_button page_modal_footer_button"
          value={language === "EN" ? "Version Française" : "English Version"}
          style={{ maxWidth: "200px" }}
          onClick={() => setLanguage(language === "EN" ? "FR" : "EN")}
        />  
  
      <div className="privacy_text">
        <pre>
          {PRIVACYTEXT[language]}
        </pre>
      </div>

    </div>
  )

   

};

export default PrivacyPage;